import DownloadButtons from '~/components/DownloadButtons'
import TrustBanner from '~/components/TrustBanner'
import useTranslator from '~/lib/useTranslator'

function HomeHeader() {
  const Translator = useTranslator()
  return (
    <>
      <div className="bg-primary-color py-10 px-4">
        <div className="w-full max-w-5xl mx-auto flex flex-row items-center gap-8">
          <img
            src="/images/header-image.svg"
            role="presentation"
            width={530}
            height={438}
            className="hidden md:block"
            alt="Header graphic"
          />

          <div className="flex flex-col gap-6 text-center items-center md:items-start md:text-left">
            <h1 className="text-white text-5xl md:text-6xl! font-bold">
              {Translator.singular('Where teams grow together')}
            </h1>
            <p className="text-white text-lg">
              <span className="hidden md:block">
                {Translator.singular(
                  'A team includes everybody, from families to coaches, friends and supporters.'
                )}
              </span>
              <span className="block">
                {Translator.singular(
                  'Easily organize and communicate with everybody on your sports team in one free and simple app.'
                )}
              </span>
            </p>
            <DownloadButtons />
            <p>{Translator.singular('Private & Secure • Free to use')}</p>
          </div>
        </div>
      </div>

      <TrustBanner />
    </>
  )
}

export default HomeHeader
